module.exports = __webpack_public_path__ + "static/info1.96b55b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/Community/info1.png
// module id = 819
// module chunks = 68530290604204